export default __webpack_public_path__ + "static/icon-12-2-486bfec9d62d9b2b55c7e2e2cac1fb69.png";